import { FlightPax, FlightProduct } from '@/api/Cart/cart.interfaces';

export function duplicatePaxList(products: FlightProduct[]): Record<string, FlightPax[]> {
    const duplicates: Record<string, FlightPax[]> = {};

    const nameKey = (pax: FlightPax) => `${pax.FirstName}|${pax.LastName}`.toLowerCase();

    products.forEach(({ Id, Pax }) => {
        const nameCounts = Pax.reduce((acc, pax) => {
            const key = nameKey(pax);
            acc.set(key, (acc.get(key) || 0) + 1);
            return acc;
        }, new Map<string, number>());

        const duplicatePax = Pax.filter((pax) => nameCounts.get(nameKey(pax))! > 1);

        if (duplicatePax.length > 0) {
            duplicates[Id] = duplicatePax;
        }
    });

    return duplicates;
}
